import React from 'react'
import {Link} from 'react-router-dom'
import {IoCheckmarkOutline} from 'react-icons/io5'

const AlertSuccess = ({text, apiText, notif, page}) => {

	return (
		<div className={notif ? "fixed top-0 left-0 w-full h-screen bg-opacity-70 backdrop-blur-md bg-white_m-200 z-50" : "hidden"}>
			<div className="flex flex-col w-full h-full justify-around items-center">
				<h2 className="font-semibold text-3xl my-4">Selamat!</h2>
				<div className="relative mb-8">
					<span className={`animate-ping absolute right-[17%] top-6 inline-flex h-24 w-24 rounded-full bg-green_m-100 opacity-75`}></span>
					<div className="flex relative text-7xl text-white_m-200 justify-center items-center h-36 w-36 bg-green_m-100 rounded-full">
						<IoCheckmarkOutline />
					</div>
				</div>
				<p className="text-center text-md font-semibold">{apiText}</p>
				<p className="text-sm text-black_m-300 mb-5 text-center p-4">{text}</p>
				{
					(page == 'data_pelanggan')
					?
					<button onClick={()=>notif(null)} className="bg-green_m-100 uppercase w-72 text-white_m-200 text-1xl py-3 px-6 rounded-2xl">
						Kembali
					</button>
					:
					((page == 'login')
					? 
					<Link to="/">
						<button onClick={()=>notif(null)} className="uppercase w-72 bg-green_m-100 text-white_m-200 text-1xl py-3 px-6 rounded-2xl">
							Silahkan Login
						</button>
					</Link>
					:
					<Link to="/DataTransaksi">
						<button onClick={()=>notif(null)} className="uppercase w-72 bg-green_m-100 text-white_m-200 text-1xl py-3 px-6 rounded-2xl">
							Cek Data Transaksi
						</button>
					</Link>
					)
				}
			</div>
		</div>
	)
}

export default AlertSuccess